function updateGoldenDeliveryTotal(purchase) {
  const total = purchase?.querySelector('[data-gg-delivered]');
  const quantity = purchase?.querySelector('[name="quantity"]');
  if (!total || !quantity) return;
  const count = Number(quantity.value);
  if (!Number.isInteger(count) || count < 1) return;
  const amount = Number(total.dataset.unitPrice) * count + Number(total.dataset.shipping);
  total.querySelector('[data-gg-delivered-value]').textContent = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(amount / 100);
}
document.addEventListener('input', (event) => {
  if (event.target.matches('[data-gg-purchase] [name="quantity"]')) updateGoldenDeliveryTotal(event.target.closest('[data-gg-purchase]'));
});
document.addEventListener('change', (event) => {
  if (event.target.matches('[data-gg-purchase] [name="quantity"]')) updateGoldenDeliveryTotal(event.target.closest('[data-gg-purchase]'));
});
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-gg-quantity]');
  if (!button) return;
  const input = button.closest('.gg-quantity').querySelector('input');
  if (button.dataset.ggQuantity === 'up') input.stepUp();
  else input.stepDown();
  input.dispatchEvent(new Event('change', { bubbles: true }));
});
document.addEventListener('change', (event) => {
  if (!event.target.matches('[data-gg-variant]')) return;
  const option = event.target.selectedOptions[0];
  const purchase = event.target.closest('[data-gg-purchase]');
  const button = purchase.querySelector('[data-gg-add]');
  const input = purchase.querySelector('[name="quantity"]');
  purchase.querySelector('[data-gg-price]').textContent = option.dataset.price;
  const total = purchase.querySelector('[data-gg-delivered]');
  if (total) total.dataset.unitPrice = option.dataset.unitPrice;
  button.disabled = option.dataset.available !== 'true';
  button.textContent = button.disabled ? purchase.dataset.soldLabel : purchase.dataset.addLabel;
  input.min = option.dataset.min || '1';
  input.step = option.dataset.step || '1';
  input.value = input.min;
  if (option.dataset.max) input.max = option.dataset.max;
  else input.removeAttribute('max');
  updateGoldenDeliveryTotal(purchase);
});

